var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:_vm.className},[_c('span',{staticClass:"btn btn-primary alt",class:{ disabled: _vm.disabled }},[_vm._v(_vm._s(_vm.buttonLabel))]),_c('input-file',{attrs:{"required":_vm.required,"disabled":_vm.disabled}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d59a9f6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/core/components/edUpload/fileUploadComponent.vue
// module id = Uqyy
// module chunks = 12